export default "__VITE_ASSET__61eca672__"